/**
 * Projekt dachu 3D: stan projektu, presety modułów, pokryć i kolorów, zapis w przeglądarce.
 *
 * Projekt to zwykły obiekt JSON (bez obiektów three.js), więc da się go zapisać w localStorage,
 * a później na koncie albo przy kliencie. Geometria liczy się z niego w `bryla.js` i `panele.js`.
 *
 * ═══ PRESETY MODUŁÓW ═══
 * Typowe wymiary i moce z kart katalogowych modułów TOPCon dostępnych w Polsce w 2026 r.
 * (108 półogniw 1722 × 1134 mm, 108 półogniw 1762 × 1134 mm, 132 półogniwa 1961 × 1134 mm,
 * 144 półogniwa 2278 × 1134 mm). Użytkownik może wpisać własne wymiary i moc.
 * `ogniwa`: kolumny × rzędy półogniw na teksturze (6 kolumn, liczba rzędów z liczby półogniw).
 */

export const TYPY_MODULOW = [
  { id: 'fullblack', nazwa: 'Full black', opis: 'czarne ogniwa, czarna rama i tło' },
  { id: 'standard', nazwa: 'Standard', opis: 'srebrna rama, białe tło między ogniwami' },
  { id: 'bifacial', nazwa: 'Bifacial', opis: 'szkło-szkło, światło przechodzi między ogniwami' },
]

export const PRESETY_MODULOW = [
  { id: 'fb-435', typ: 'fullblack', nazwa: '435 W, 108 półogniw', dlugosc: 1.722, szerokosc: 1.134, grubosc: 0.03, moc: 435, rzedyOgniw: 18 },
  { id: 'fb-455', typ: 'fullblack', nazwa: '455 W, 108 półogniw', dlugosc: 1.762, szerokosc: 1.134, grubosc: 0.03, moc: 455, rzedyOgniw: 18, domyslny: true },
  { id: 'st-465', typ: 'standard', nazwa: '465 W, 108 półogniw', dlugosc: 1.762, szerokosc: 1.134, grubosc: 0.03, moc: 465, rzedyOgniw: 18, domyslny: true },
  { id: 'st-505', typ: 'standard', nazwa: '505 W, 132 półogniwa', dlugosc: 1.961, szerokosc: 1.134, grubosc: 0.03, moc: 505, rzedyOgniw: 22 },
  { id: 'bf-450', typ: 'bifacial', nazwa: '450 W, 108 półogniw', dlugosc: 1.722, szerokosc: 1.134, grubosc: 0.03, moc: 450, rzedyOgniw: 18, bifacjalnosc: 0.8 },
  { id: 'bf-590', typ: 'bifacial', nazwa: '590 W, 144 półogniwa', dlugosc: 2.278, szerokosc: 1.134, grubosc: 0.03, moc: 590, rzedyOgniw: 24, bifacjalnosc: 0.8, domyslny: true },
]

// Typowy moduł rodzaju (decyzja właściciela 2026-10-11): jeden na rodzaj, bez listy do wyboru; bifacial duży,
// ponad 2 m. Pozostałe presety zostają dla zapisanych projektów.
export const typowyModul = (typ) => PRESETY_MODULOW.find((x) => x.typ === typ && x.domyslny) || PRESETY_MODULOW.find((x) => x.typ === typ)

export const presetModulu = (id) => PRESETY_MODULOW.find((p) => p.id === id) || PRESETY_MODULOW[0]

/** Pokrycia dachu. Klucze jak w `lib/konstrukcja.js` tam, gdzie się pokrywają (koszt konstrukcji). */
export const POKRYCIA = [
  { id: 'dachowka_ceramiczna', nazwa: 'Dachówka ceramiczna', kolory: ['ceglasty', 'czerwony', 'brazowy', 'grafitowy', 'czarny'] },
  { id: 'dachowka_betonowa', nazwa: 'Dachówka betonowa', kolory: ['grafitowy', 'czarny', 'brazowy', 'ceglasty'] },
  { id: 'dachowka_karpiowka', nazwa: 'Karpiówka', kolory: ['ceglasty', 'czerwony', 'brazowy'] },
  { id: 'blachodachowka', nazwa: 'Blachodachówka', kolory: ['grafitowy', 'czarny', 'brazowy', 'wisniowy'] },
  { id: 'rabek', nazwa: 'Blacha na rąbek', kolory: ['grafitowy', 'czarny', 'antracyt', 'srebrny'] },
  { id: 'blacha_trapezowa', nazwa: 'Blacha trapezowa', kolory: ['grafitowy', 'srebrny', 'brazowy'] },
  { id: 'dachowka_bitumiczna', nazwa: 'Gont bitumiczny', kolory: ['czarny', 'brazowy', 'czerwony'] },
  { id: 'membrana', nazwa: 'Membrana lub papa', kolory: ['grafitowy', 'jasnoszary'] },
]

export const KOLORY_POKRYC = {
  ceglasty: { nazwa: 'ceglasty', hex: '#9a4a2c' },
  czerwony: { nazwa: 'czerwony', hex: '#8f2f22' },
  brazowy: { nazwa: 'brązowy', hex: '#4a3226' },
  grafitowy: { nazwa: 'grafitowy', hex: '#3b3e43' },
  czarny: { nazwa: 'czarny', hex: '#1c1d20' },
  antracyt: { nazwa: 'antracyt', hex: '#2b2f33' },
  wisniowy: { nazwa: 'wiśniowy', hex: '#5a2224' },
  srebrny: { nazwa: 'srebrny', hex: '#9da3a8' },
  jasnoszary: { nazwa: 'jasnoszary', hex: '#9a9c9e' },
}

export const pokrycie = (id) => POKRYCIA.find((p) => p.id === id) || POKRYCIA[0]

export const ELEWACJE = [
  { id: 'tynk', nazwa: 'Tynk' },
  { id: 'klinkier', nazwa: 'Klinkier' },
  { id: 'deska', nazwa: 'Deska elewacyjna' },
]

export const KOLORY_ELEWACJI = [
  { id: 'bialy', nazwa: 'biały', hex: '#efeee9' },
  { id: 'zlamany', nazwa: 'złamana biel', hex: '#e8e1d3' },
  { id: 'jasnoszary', nazwa: 'jasnoszary', hex: '#cfd0cd' },
  { id: 'szary', nazwa: 'szary', hex: '#9fa1a0' },
  { id: 'grafit', nazwa: 'grafit', hex: '#4b4e52' },
  { id: 'piaskowy', nazwa: 'piaskowy', hex: '#d3c2a0' },
  { id: 'bezowy', nazwa: 'beżowy', hex: '#c4ad8e' },
  { id: 'oliwkowy', nazwa: 'oliwkowy', hex: '#8f8e74' },
]

export const KOLORY_KLINKIERU = [
  { id: 'czerwony', nazwa: 'czerwony', hex: '#8c3b2a' },
  { id: 'brazowy', nazwa: 'brązowy', hex: '#5d3a2c' },
  { id: 'grafitowy', nazwa: 'grafitowy', hex: '#3d3b3b' },
  { id: 'piaskowy', nazwa: 'piaskowy', hex: '#b89a74' },
]

export const KOLORY_DESKI = [
  { id: 'naturalny', nazwa: 'naturalny', hex: '#a77a4f' },
  { id: 'orzech', nazwa: 'orzech', hex: '#6b4a32' },
  { id: 'szary', nazwa: 'szarość', hex: '#7c7a74' },
  { id: 'czarny', nazwa: 'czarny', hex: '#2a2a2a' },
]

export const KOLORY_STOLARKI = [
  { id: 'antracyt', nazwa: 'antracyt', hex: '#33373c' },
  { id: 'bialy', nazwa: 'biały', hex: '#f2f2ef' },
  { id: 'zloty_dab', nazwa: 'złoty dąb', hex: '#9a6633' },
  { id: 'czarny', nazwa: 'czarny', hex: '#1e1f21' },
]

export const KOLORY_RYNIEN = [
  { id: 'grafit', nazwa: 'grafitowe', hex: '#3a3d41' },
  { id: 'brazowe', nazwa: 'brązowe', hex: '#4a3428' },
  { id: 'biale', nazwa: 'białe', hex: '#ecebe7' },
  { id: 'czarne', nazwa: 'czarne', hex: '#1d1e20' },
]

export const TYPY_DACHU = [
  { id: 'dwuspadowy', nazwa: 'Dwuspadowy' },
  { id: 'czterospadowy', nazwa: 'Czterospadowy' },
  { id: 'jednospadowy', nazwa: 'Jednospadowy' },
  { id: 'plaski', nazwa: 'Płaski' },
  { id: 'mansardowy', nazwa: 'Mansardowy' },
  { id: 'naczolkowy', nazwa: 'Naczółkowy' },
]

/**
 * Elementy otoczenia. `naDachu`: stawiane na połaci (przeszkoda dla modułów, kształt w `przeszkody.js`),
 * `cien`: rzuca cień w analizie uzysku (drobne urządzenia przy ziemi nie zacieniają dachu).
 * `zapas`: odstęp modułów od przeszkody w metrach. Wymiary przeszkód stojących (komin, antena, wentylacja,
 * inna) to podstawa szerokość × głębokość, leżących w połaci (okno, wyłaz) szerokość wzdłuż okapu × długość
 * wzdłuż spadku.
 */
export const TYPY_ELEMENTOW = [
  { id: 'komin', nazwa: 'Komin', naDachu: true, cien: true, domyslne: { szerokosc: 0.5, glebokosc: 0.6, ponadDach: 1.0, zapas: 0.3 } },
  { id: 'okno_dachowe', nazwa: 'Okno dachowe', naDachu: true, cien: false, domyslne: { szerokosc: 0.78, dlugosc: 1.18, zapas: 0.2 } },
  { id: 'wylaz', nazwa: 'Wyłaz', naDachu: true, cien: false, domyslne: { szerokosc: 0.6, dlugosc: 0.8, zapas: 0.2 } },
  { id: 'antena', nazwa: 'Antena', naDachu: true, cien: true, domyslne: { szerokosc: 0.3, glebokosc: 0.3, wysokosc: 1.8, zapas: 0.3 } },
  { id: 'wentylacja', nazwa: 'Wentylacja', naDachu: true, cien: true, domyslne: { szerokosc: 0.25, glebokosc: 0.25, wysokosc: 0.5, zapas: 0.2 } },
  { id: 'inna', nazwa: 'Inna przeszkoda', naDachu: true, cien: true, domyslne: { szerokosc: 0.6, glebokosc: 0.6, wysokosc: 0.3, zapas: 0.2 } },
  // Pasy w osiach połaci; stopnie i kratka to warianty ławy i płotka (wybór po wstawieniu, bez osobnego przycisku).
  { id: 'lawa_kominiarska', nazwa: 'Ława kominiarska', naDachu: true, cien: false, domyslne: { kierunek: 'spadek', doKrawedzi: true, dlugosc: 3, szerokosc: 0.3, zapas: 0.1 } },
  { id: 'stopnie_kominiarskie', nazwa: 'Stopnie kominiarskie', naDachu: true, cien: false, wariantOd: 'lawa_kominiarska', domyslne: { kierunek: 'spadek', doKrawedzi: true, dlugosc: 3, szerokosc: 0.4, zapas: 0.1 } },
  { id: 'plotek_sniegowy', nazwa: 'Płotek śniegowy', naDachu: true, cien: false, domyslne: { kierunek: 'okap', doKrawedzi: true, dlugosc: 4, szerokosc: 0.15, zapas: 0.05 } },
  { id: 'kratka_sniegowa', nazwa: 'Kratka śniegowa', naDachu: true, cien: false, wariantOd: 'plotek_sniegowy', domyslne: { kierunek: 'okap', doKrawedzi: true, dlugosc: 4, szerokosc: 0.15, zapas: 0.05 } },
  { id: 'lukarna', nazwa: 'Lukarna', naDachu: true, cien: true, domyslne: { szerokosc: 2.2, wysokosc: 1.4, dach: 'dwuspadowy', kat: 35, zapas: 0.3 } },
  { id: 'drzewo_lisciaste', nazwa: 'Drzewo liściaste', cien: true, domyslne: { wysokosc: 9, korona: 6 } },
  { id: 'drzewo_iglaste', nazwa: 'Drzewo iglaste', cien: true, domyslne: { wysokosc: 11, korona: 4 } },
  { id: 'pompa_ciepla', nazwa: 'Pompa ciepła', cien: false, domyslne: {} },
  { id: 'wallbox', nazwa: 'Wallbox', cien: false, domyslne: {} },
]

/**
 * Nawierzchnia pod konstrukcją gruntową. `albedo` decyduje o zysku z tyłu modułu bifacjalnego
 * (typowe wartości z literatury: trawa 0,2, piasek 0,3–0,4, beton 0,25–0,35, żwir jasny 0,3–0,4).
 */
export const NAWIERZCHNIE = [
  { id: 'trawa', nazwa: 'Trawa', albedo: 0.2 },
  { id: 'piasek', nazwa: 'Piasek', albedo: 0.35 },
  { id: 'zwir', nazwa: 'Żwir jasny', albedo: 0.32 },
  { id: 'beton', nazwa: 'Beton', albedo: 0.3 },
  { id: 'kostka', nazwa: 'Kostka brukowa', albedo: 0.22 },
]
export const nawierzchnia = (id) => NAWIERZCHNIE.find((x) => x.id === id) || NAWIERZCHNIE[0]

export const typElementu = (id) => TYPY_ELEMENTOW.find((t) => t.id === id)

/** Domyślne skrzydło: dom 12 × 9 m, dach dwuspadowy 38°, kalenica wzdłuż, front na południe. */
export const noweSkrzydlo = (nadpisz = {}) => ({
  id: nadpisz.id || `s${Math.random().toString(36).slice(2, 7)}`,
  srodek: [0, 0],
  dlugosc: 12,
  szerokosc: 9,
  obrot: 0,
  wysokoscScian: 3.4,
  rodzaj: 'budynek',
  okna: true,
  ...nadpisz,
  dach: {
    typ: 'dwuspadowy', kat: 38, kalenica: 'wzdluz', spadek: 'przod',
    okap: 0.5, okapSzczytowy: 0.3, grubosc: 0.25, attyka: 0.4,
    ...(nadpisz.dach || {}),
  },
})

/* ═══ Skrzydła przy ścianie ═════════════════════════════════════════════════ */

export const SCIANY_PRZYLEGANIA = ['przod', 'tyl', 'lewo', 'prawo']

// Oś od środka skrzydła do ściany (normalna na zewnątrz) i oś wzdłuż ściany, [x, z]; jak ramka w `bryla.js`:
// x' = (cos, −sin), z' = (sin, cos), przód to +z', prawo to +x'.
const osieSciany = (rodzic, sciana) => {
  const t = ((rodzic.obrot || 0) * Math.PI) / 180
  const xp = [Math.cos(t), -Math.sin(t)]
  const zp = [Math.sin(t), Math.cos(t)]
  const minus = (v) => [-v[0], -v[1]]
  if (sciana === 'tyl') return { na: minus(zp), wzdluz: xp, przekroj: 'szerokosc' }
  if (sciana === 'prawo') return { na: xp, wzdluz: zp, przekroj: 'dlugosc' }
  if (sciana === 'lewo') return { na: minus(xp), wzdluz: zp, przekroj: 'dlugosc' }
  return { na: zp, wzdluz: xp, przekroj: 'szerokosc' }
}

/**
 * Położenie skrzydła przylegającego do ściany innego (dobudówka, garaż, wiata), `przylega = { do, sciana,
 * przesuniecie }`: stoi równo przy ścianie (ściany się stykają), z tym samym obrotem co skrzydło, do którego
 * przylega, a `przesuniecie` przesuwa jego środek wzdłuż tej ściany (m, dodatnio w stronę +x' albo +z').
 */
export const polozeniePrzylegajacego = (rodzic, sk, przylega = {}) => {
  const { na, wzdluz, przekroj } = osieSciany(rodzic, przylega.sciana)
  const odl = rodzic[przekroj] / 2 + sk[przekroj] / 2
  const s = przylega.przesuniecie || 0
  const r = (v) => Math.round(v * 1000) / 1000
  return {
    srodek: [r(rodzic.srodek[0] + na[0] * odl + wzdluz[0] * s), r(rodzic.srodek[1] + na[1] * odl + wzdluz[1] * s)],
    obrot: rodzic.obrot || 0,
  }
}

/** Największe przesunięcie wzdłuż ściany, przy którym skrzydła nadal stykają się na co najmniej 0,5 m. */
export const zakresPrzesuniecia = (rodzic, sk, sciana) => {
  const wzdluzSciany = osieSciany(rodzic, sciana).przekroj === 'szerokosc' ? 'dlugosc' : 'szerokosc'
  return Math.max(0, (rodzic[wzdluzSciany] + sk[wzdluzSciany]) / 2 - 0.5)
}

/**
 * Ustawia skrzydła z `przylega` przy ich ścianach (w miejscu, na tablicy z projektu). Dwa przebiegi, żeby
 * dobudówka dobudówki też poszła za domem.
 */
export const dopasujPrzylegle = (skrzydla) => {
  if (!Array.isArray(skrzydla)) return skrzydla
  for (let k = 0; k < 2; k++) {
    for (const sk of skrzydla) {
      const rodzic = sk.przylega && skrzydla.find((x) => x.id === sk.przylega.do && x !== sk)
      if (!rodzic) continue
      Object.assign(sk, polozeniePrzylegajacego(rodzic, sk, sk.przylega))
    }
  }
  return skrzydla
}

/**
 * Rodzaj instalacji („dach” albo wolnostojąca „grunt”) na projekcie `d` (szkic do zmiany). Przy przejściu na grunt
 * budynek zostaje jako otoczenie, a konstrukcja staje 6 m na południe od niego (nie w środku domu); potem przesuwa się
 * ją myszą w scenie. `obrysy`: obrysy bryły (`bryla.obrysy`). Zwraca true, gdy rodzaj się zmienił.
 */
export const ustawRodzajInstalacji = (d, rodzaj, obrysy = []) => {
  if (d.rodzaj === rodzaj) return false
  d.rodzaj = rodzaj
  if (rodzaj !== 'grunt') return true
  d.moduly.tryb = 'liczba'
  const pkt = (obrysy || []).flatMap((o) => o.punkty)
  if (pkt.length) {
    const xs = pkt.map((q) => q[0])
    d.grunt.srodek = [(Math.min(...xs) + Math.max(...xs)) / 2, Math.max(...pkt.map((q) => q[1])) + 6]
  }
  return true
}

/**
 * Ile sztuk magazynu daje pojemność projektu (`magazyn.pojemnosc` to pojemność całości): wielokrotność sztuki modelu.
 * Pojemność wpisana inaczej (np. z karty klienta) to 1, bo nie da się jej rozbić na sztuki.
 */
export const liczbaMagazynow = (magazyn) => {
  const sztuka = Number(magazyn?.model?.pojemnoscKwh)
  const calosc = Number(magazyn?.pojemnosc)
  if (!(sztuka > 0) || !(calosc > 0)) return 1
  const n = Math.round(calosc / sztuka)
  return n >= 1 && Math.abs(n * sztuka - calosc) < 0.05 ? n : 1
}

export const nowyProjekt = () => ({
  wersja: 1,
  rodzaj: 'dach',
  lokalizacja: null,
  budynek: { skrzydla: [noweSkrzydlo({ id: 'dom' })] },
  wyglad: {
    elewacja: { material: 'tynk', kolor: '#efeee9' },
    cokol: { kolor: '#55585c' },
    stolarka: { kolor: '#33373c' },
    pokrycie: { typ: 'dachowka_ceramiczna', kolor: 'grafitowy' },
    rynny: { kolor: '#3a3d41' },
  },
  moduly: {
    preset: 'fb-455',
    wlasny: null,
    model: null,
    tryb: 'max',
    cel: { wedlug: 'liczba', liczba: 20, kwp: 8.7 },
    naPolaci: {},
    orientacja: 'pion',
    margines: 0.3,
    polacie: {},
    usuniete: [],
    dodane: [],
    plaski: { uklad: 'poludnie', kat: 13 },
  },
  // `obszar`: wielokąt z mapy [[x, z]...] (metry sceny od lokalizacja.e0/n0, z na południe); bez niego blok w `srodek`.
  grunt: { uklad: 'poludnie', kat: 30, rzedy: 2, wysokoscDolna: 0.8, orientacja: 'poziom', obrot: 0, nawierzchnia: 'trawa', srodek: [0, 0], obszar: null },
  falownik: { model: null, miejsce: 'zewnatrz', sciana: null, polozenie: 0.5 },
  magazyn: { model: null, pojemnosc: 0 },
  elementy: [],
  otoczenie: { ortofotomapa: true, nmpt: true, drzewa: true, budynki: false, wyciete: [] },
  czas: { miesiac: 6, dzien: 21, godzina: 13 },
})

/** Uzupełnia zapisany projekt o pola dodane w nowszych wersjach (płytkie scalenie gałęzi). */
export const uzupelnijProjekt = (p) => {
  const n = nowyProjekt()
  if (!p) return n
  return {
    ...n,
    ...p,
    wyglad: { ...n.wyglad, ...(p.wyglad || {}) },
    moduly: { ...n.moduly, ...(p.moduly || {}), cel: { ...n.moduly.cel, ...(p.moduly?.cel || {}) } },
    grunt: { ...n.grunt, ...(p.grunt || {}) },
    falownik: { ...n.falownik, ...(p.falownik || {}) },
    magazyn: { ...n.magazyn, ...(p.magazyn || {}) },
    otoczenie: { ...n.otoczenie, ...(p.otoczenie || {}) },
    czas: { ...n.czas, ...(p.czas || {}) },
    // Falownik, magazyn i konstrukcja gruntowa nie są już elementami otoczenia (osobne kroki).
    elementy: (p.elementy || []).filter((e) => TYPY_ELEMENTOW.some((t) => t.id === e.typ)),
  }
}

/**
 * Moduł użyty w projekcie: model z katalogu (z ewentualną korektą wymiarów), a bez niego preset
 * albo wymiary wpisane przez użytkownika.
 */
export const modulProjektu = (moduly) => {
  if (moduly.model) {
    // Model z katalogu na typowym module tego samego typu. Pola, których katalog nie podał (null), zostają
    // z typowego modułu: null nadpisujący wymiar dałby NaN w układzie modułów.
    const baza = presetModulu(PRESETY_MODULOW.find((x) => x.typ === moduly.model.typ)?.id)
    const znane = Object.fromEntries(Object.entries(moduly.model).filter(([, v]) => v != null))
    return { ...baza, ...znane, id: moduly.model.id ?? 'katalog' }
  }
  const p = presetModulu(moduly.preset)
  return moduly.wlasny ? { ...p, ...moduly.wlasny, id: 'wlasny' } : p
}

const KLUCZ = 'vv_projekt_dachu_3d_v1'

export const wczytajZapisany = () => {
  try {
    const s = window.localStorage.getItem(KLUCZ)
    if (!s) return null
    const p = JSON.parse(s)
    return p && p.wersja === 1 ? uzupelnijProjekt(p) : null
  } catch { return null }
}

export const zapiszProjekt = (projekt) => {
  try { window.localStorage.setItem(KLUCZ, JSON.stringify(projekt)) } catch { /* bez pamięci przeglądarki */ }
}

export const usunZapisany = () => {
  try { window.localStorage.removeItem(KLUCZ) } catch { /* bez pamięci przeglądarki */ }
}

/** Liczba z separatorem dziesiętnym po polsku: 8,6. */
export const pl = (x, miejsc = 1) => (x == null || !Number.isFinite(x) ? '' : x.toLocaleString('pl-PL', {
  minimumFractionDigits: miejsc, maximumFractionDigits: miejsc,
}))
